import { render, staticRenderFns } from "./PostReport.vue?vue&type=template&id=50f2ffb9&scoped=true"
import script from "./PostReport.vue?vue&type=script&lang=js"
export * from "./PostReport.vue?vue&type=script&lang=js"
import style0 from "./PostReport.vue?vue&type=style&index=0&id=50f2ffb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f2ffb9",
  null
  
)

export default component.exports